// extracted by mini-css-extract-plugin
export var container = "_5g-0";
export var fallback = "_5g-5";
export var fallbackIcon = "_5g-6";
export var hidden = "_5g-2";
export var image = "_5g-3";
export var loaded = "_5g-4";
export var placeholder = "_5g-1";